import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-txc-simple-nav',
  templateUrl: './txc-simple-nav.component.html',
  styleUrls: ['./txc-simple-nav.component.scss']
})
export class TxcSimpleNavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
